// modal-template-create-student-task.js
import axios from 'axios';

const classPrefix = 'modal-template-create-student-task';
const dataPrefix = 'data-modal-template-create-student-task';
import {input} from '../../input/input';
import {select} from '../../select/select';

export function modalTemplateCreateStudentTask($container, params = {task_id: null}) {
    const $template = document.querySelector(`[${dataPrefix}-template]`)
    let $form = null;
    let editMode = false;
    let editTaskId = params.task_id || null;
    let editData = null; // will store loaded task info
    // helper reference so we can call createTasksSelect from outside renderCaseFields
    let globalCreateTasksSelect = null;

    const payload = {
        type: 'case',
        demand_id: null,
        exercise_id: null,
        title: null,
        // other fields (due_at, description...) могут быть добавлены при необходимости
    };

    init();

    async function init() {
        console.log('modalTemplateCreateStudentTask init, editTaskId=', editTaskId)
        const $modalClone = document.importNode($template.content, true)
        const $confirm = $modalClone.querySelector(`[${dataPrefix}-confirm]`);
        const $tabs = $modalClone.querySelectorAll(`[${dataPrefix}-switch]`);

        $form = $modalClone.querySelector(`[${dataPrefix}-form]`);

        if ($confirm) $confirm.disabled = true;
        initTabs($tabs);

        ensureStatusField($form);

        // if editing - load task data first
        if (editTaskId) {
            editMode = true;
            if ($confirm) {
                $confirm.textContent = 'Сохранить';
                $confirm.disabled = true;
            }
            try {
                editData = await fetchTaskInfo(editTaskId);
                if (!editData) throw new Error('Не удалось получить данные таска');
                // apply to payload
                payload.type = editData.type || payload.type;
                payload.demand_id = editData.demand_id ?? null;
                payload.exercise_id = editData.exercise_id ?? null;
                payload.title = editData.title ?? null;

                // --- NEW: programmatically activate the matching tab if it exists
                // this will trigger the same click handler you set up in initTabs
                const $tabToActivate = $modalClone.querySelector(`[${dataPrefix}-switch][data-type="${payload.type}"]`);
                if ($tabToActivate) {
                    // trigger click so tab UI class + renderTab happen consistently
                    $tabToActivate.click();
                } else {
                    // fallback — render tab manually if matching tab not found
                    renderTab(payload.type);
                }

                // then populate fields (wait for selects to be created by render)
                await populateFieldsAfterRender(editData);
            } catch (err) {
                console.error('Ошибка при загрузке таска:', err);
                setStatusMessage($form, 'Ошибка при загрузке данных таска', true);
                // still render default tab
                renderTab(payload.type);
            }
        } else {
            // create mode
            renderTab(payload.type);
        }

        if ($confirm) {
            $confirm.disabled = false;
            $confirm.addEventListener('click', async () => {
                if (editMode) {
                    await submitEdit($form, $confirm);
                } else {
                    await submitCreate($form, $confirm);
                }
            });
        }

        $container.appendChild($modalClone)
    }

    function initTabs($tabs) {
        $tabs.forEach($tab => {
            $tab.addEventListener('click', () => {
                $tabs.forEach($tab => $tab.classList.remove(`${classPrefix}__switch-item--active`));
                $tab.classList.add(`${classPrefix}__switch-item--active`);

                payload.type = $tab.dataset.type;
                renderTab(payload.type);
                // if in edit mode and we switched tab manually, clear/refresh fields
                if (editMode) {
                    // if switched to case/troika we might need to repopulate selects from editData
                    // fire-and-forget: allow async population
                    populateFieldsAfterRender(editData);
                }
            });
        });

        // set active tab according to payload.type if tabs exist
        if ($tabs && $tabs.length) {
            $tabs.forEach($tab => {
                if ($tab.dataset.type === payload.type) {
                    $tab.classList.add(`${classPrefix}__switch-item--active`);
                } else {
                    $tab.classList.remove(`${classPrefix}__switch-item--active`);
                }
            });
        }
    }

    function renderTab($tab) {
        switch ($tab) {
            case 'troika':
                renderTroikaFields();
                break;
            case 'case':
                renderCaseFields();
                break;
            default:
                break;
        }
    }

    function renderTroikaFields() {
        // очищаем от предыдущих
        $form.innerHTML = '';

        input($form, {
            type: 'text',
            label: 'Название задания',
            name: 'title',
            autocomplete: 'title',
            required: true,
        });

        select($form, {
            name: 'theme',
            label: 'Тема',
            placeholder: '',
            searchable: true,
            required: true,
            pageSize: 20,
            // Функция подгрузки опций с API
            loadOptions: async ({search, offset, limit}) => {
                const q = encodeURIComponent(search || '');
                try {
                    const res = await fetch(`/api/demands-for-select?search=${q}&offset=${offset}&limit=${limit}`);
                    if (!res.ok) throw new Error('Network error');
                    const json = await res.json();
                    // Ожидаемый формат: { items: [{ value, label }], hasMore: boolean }
                    return json;
                } catch (err) {
                    console.error('Ошибка при загрузке:', err);
                    return {items: [], hasMore: false};
                }
            },
            onSelect: (item) => {
                console.log('Выбрана тема:', item);
                payload.demand_id = item.value;
            },
            // необязательное поле: если select поддерживает предустановленный выбор
            initial: null,
        });
    }

    function renderCaseFields() {
        // очищаем от предыдущих
        $form.innerHTML = '';

        input($form, {
            type: 'text',
            label: 'Название задания',
            name: 'title',
            autocomplete: 'title',
            required: true,
        });

        // создаём контейнер для exercise select чтобы иметь к нему доступ
        const $exerciseContainer = document.createElement('div');
        $form.appendChild($exerciseContainer);

        select($exerciseContainer, {
            name: 'exercise',
            label: 'Кейс',
            placeholder: '',
            searchable: true,
            required: true,
            pageSize: 20,
            // Функция подгрузки опций с API
            loadOptions: async ({search, offset, limit}) => {
                const q = encodeURIComponent(search || '');
                try {
                    const res = await fetch(`/api/exercises-for-select?search=${q}&offset=${offset}&limit=${limit}`);
                    if (!res.ok) throw new Error('Network error');
                    const json = await res.json();
                    // Ожидаемый формат: { items: [{ value, label }], hasMore: boolean }
                    return json;
                } catch (err) {
                    console.error('Ошибка при загрузке упражнений:', err);
                    return {items: [], hasMore: false};
                }
            },
            onSelect: (item) => {
                console.log('Выбрано упражнение:', item);
                // item.value ожидается как videoId
                payload.exercise_id = item.value;
                // render tasks select for this video
                if (typeof globalCreateTasksSelect === 'function') {
                    globalCreateTasksSelect(item.value);
                }
            },
            initial: null,
        });

        const $taskContainerWrapper = document.createElement('div');
        $form.appendChild($taskContainerWrapper);

        function createTasksSelect(videoId) {
            // очищаем область задач
            $taskContainerWrapper.innerHTML = '';

            // если videoId нет — показываем подсказку
            if (!videoId) {
                const $hint = document.createElement('div');
                $hint.textContent = 'Выберите кейс, чтобы загрузить упражнения';
                $taskContainerWrapper.appendChild($hint);
                return;
            }

            const $taskContainer = document.createElement('div');
            $taskContainerWrapper.appendChild($taskContainer);

            // создаём селект задач с загрузкой по видео
            select($taskContainer, {
                name: 'task',
                label: 'Упражнение кейса',
                placeholder: '',
                searchable: false,
                required: true,
                pageSize: 20,
                loadOptions: async ({search, offset, limit}) => {
                    const q = encodeURIComponent(search || '');
                    try {
                        const res = await fetch(`/api/tasks-for-select/${encodeURIComponent(videoId)}?search=${q}&offset=${offset}&limit=${limit}`);
                        if (!res.ok) throw new Error('Network error');
                        const json = await res.json();
                        // Ожидаемый формат от API: { items: [{ value, label }], hasMore: boolean }
                        return json;
                    } catch (err) {
                        console.error('Ошибка при загрузке задач для кейса:', err);
                        return {items: [], hasMore: false};
                    }
                },
                onSelect: (item) => {
                    console.log('Выбрано упражнение кейса:', item);
                    payload.exercise_id = videoId; // video id stays in exercise_id (as in backend mapping)
                    payload.task_id = item.value;
                },
                initial: null,
            });
        }

        // expose createTasksSelect so other parts can call it (e.g. populateFieldsAfterRender)
        globalCreateTasksSelect = createTasksSelect;

        // if in edit mode and we already know exercise_id/task_id — try to prefill
        if (editMode && editData && editData.exercise_id) {
            (async () => {
                try {
                    // ensure exercise option exists and is selected
                    await ensureOptionAndSet('exercise', editData.exercise_id, `/api/exercises-for-select?search=&offset=0&limit=200`);
                    payload.exercise_id = editData.exercise_id;

                    // create tasks select for this video
                    createTasksSelect(editData.exercise_id);

                    // ensure task option exists and is selected
                    if (editData.task_id) {
                        await ensureOptionAndSet('task', editData.task_id, `/api/tasks-for-select/${encodeURIComponent(editData.exercise_id)}?search=&offset=0&limit=200`);
                        payload.task_id = editData.task_id;
                    }
                } catch (e) {
                    console.warn('Ошибка предварительной установки exercise/task при редактировании', e);
                }
            })();
        }
    }

    function ensureStatusField($form) {
        // общий статус/ошибка
        let $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) {
            $status = document.createElement('div');
            $status.className = `${classPrefix}__status`;
            $form.appendChild($status);
        }
    }

    function setStatusMessage($form, message, isError = true) {
        const $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) return;
        $status.textContent = message || '';
        $status.style.display = message ? 'block' : 'none';
        $status.classList.toggle('is-error', isError);
    }

    function clearErrors($form) {
        // удаляем старые текстовые сообщения ошибок под input'ами
        $form.querySelectorAll(`.${classPrefix}__field-error`).forEach(e => e.remove());
        setStatusMessage($form, '');
        // сброс состояния инпутов
        $form.querySelectorAll('input, textarea').forEach(el => {
            el.classList.remove('is-invalid');
        });
    }

    async function submitCreate($form, $confirmBtn) {
        clearErrors($form);
        setStatusMessage($form, '');

        // собираем поля по имени
        $form.querySelectorAll('input[name], textarea[name]').forEach(($el) => {
            const name = $el.getAttribute('name');
            payload[name] = $el.value;
        });

        // UI: блокируем кнопку
        const oldBtnText = $confirmBtn.textContent;
        $confirmBtn.setAttribute('disabled', 'true');
        $confirmBtn.classList.add('is-loading');
        $confirmBtn.textContent = 'Создаем...';

        // Настройки axios для laravel
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Accept'] = 'application/json';

        // CSRF: попробуем прочитать meta-tag, если он есть
        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (metaToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = metaToken;
        }

        try {
            const response = await axios.post('api/group/' + window.CURRENT_GROUP_ID  + '/task', payload);

            console.log('DISPATCH EVENT')
            document.dispatchEvent(new CustomEvent('modal-template:close'));
            document.dispatchEvent(new CustomEvent('account-task:created'));
        } catch (error) {
            console.error(error);
            setStatusMessage($form, error?.response?.data?.message || 'Ошибка при создании', true);
        } finally {
            // разблокируем кнопку
            $confirmBtn.removeAttribute('disabled');
            $confirmBtn.classList.remove('is-loading');
            $confirmBtn.textContent = oldBtnText;
        }
    }

    async function submitEdit($form, $confirmBtn) {
        clearErrors($form);
        setStatusMessage($form, '');

        // собираем поля по имени
        $form.querySelectorAll('input[name], textarea[name]').forEach(($el) => {
            const name = $el.getAttribute('name');
            payload[name] = $el.value;
        });

        // UI: блокируем кнопку
        const oldBtnText = $confirmBtn.textContent;
        $confirmBtn.setAttribute('disabled', 'true');
        $confirmBtn.classList.add('is-loading');
        $confirmBtn.textContent = 'Сохраняем...';

        // Настройки axios для laravel
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Accept'] = 'application/json';

        // CSRF: попробуем прочитать meta-tag, если он есть
        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (metaToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = metaToken;
        }

        try {
            // отправляем PUT на ресурс таска — ожидается route: PUT api/group/{groupId}/task/{taskId}
            console.log('PAYLOAD:', payload);

            const url = 'api/task/' + encodeURIComponent(editTaskId);
            const response = await axios.put(url, payload);

            console.log('RESPONSE:', response);
            console.log('DISPATCH EVENT EDIT')
            document.dispatchEvent(new CustomEvent('modal-template:close'));
            document.dispatchEvent(new CustomEvent('account-task:created'));
        } catch (error) {
            console.error(error);
            setStatusMessage($form, error?.response?.data?.message || 'Ошибка при сохранении', true);
        } finally {
            // разблокируем кнопку
            $confirmBtn.removeAttribute('disabled');
            $confirmBtn.classList.remove('is-loading');
            $confirmBtn.textContent = oldBtnText;
        }
    }

    // Попытка получить инфу о таске
    async function fetchTaskInfo(taskId) {
        const url = `/api/task/${encodeURIComponent(taskId)}`;
        try {
            const res = await fetch(url, { credentials: 'same-origin' });
            if (!res.ok) {
                console.warn('fetchTaskInfo: fetch failed', res.status, url);
                return null;
            }
            const json = await res.json();
            const data = json?.data ? json.data : json;

            return {
                id: data.id ?? null,
                title: data.title ?? null,
                group_id: data.group_id ?? data.groupId ?? null,
                type: data.type ?? null,
                // backend возвращает exercise_id как video.id и task_id как internal exercise.id
                exercise_id: data.exercise_id ?? data.video_id ?? data.exerciseId ?? null,
                task_id: data.task_id ?? data.taskId ?? null,
                demand_id: data.demand_id ?? data.demandId ?? null,
            };
        } catch (e) {
            console.error('fetchTaskInfo error', e);
            return null;
        }
    }

    // Вспомогательная: получить опции по URL (возвращает items[])
    async function fetchOptionsForSelect(url) {
        try {
            const res = await fetch(url, { credentials: 'same-origin' });
            if (!res.ok) return [];
            const json = await res.json();
            if (Array.isArray(json)) return json;
            if (json && Array.isArray(json.items)) return json.items;
            return [];
        } catch (e) {
            console.warn('fetchOptionsForSelect error', e, url);
            return [];
        }
    }

    // Убедиться, что native <select name="..."> содержит option с value и установить его, если нужно подгрузить label — используем fetchUrl
    async function ensureOptionAndSet(selectName, value, fetchUrl = null) {
        if (!selectName || value == null) return false;
        const $native = $form.querySelector(`select[name="${selectName}"]`);
        if (!$native) {
            // select ещё не отрисован
            return false;
        }
        const strVal = String(value);

        // попытка найти option
        let opt = $native.querySelector(`option[value="${strVal}"]`);
        if (!opt && fetchUrl) {
            const items = await fetchOptionsForSelect(fetchUrl);
            const found = items.find(i => String(i.value) === String(value));
            if (found) {
                opt = document.createElement('option');
                opt.value = String(found.value);
                opt.textContent = String(found.label);
                $native.appendChild(opt);
            }
        }

        if (!opt) {
            // fallback: создаём option с label == value
            const fallbackOpt = document.createElement('option');
            fallbackOpt.value = strVal;
            fallbackOpt.textContent = String(value);
            $native.appendChild(fallbackOpt);
            opt = fallbackOpt;
        }

        $native.value = opt.value;
        $native.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
    }

    // После рендера полей — подставляем значения для инпутов/селектов
    async function populateFieldsAfterRender(data) {
        if (!data) return;
        const $title = $form.querySelector('input[name="title"], textarea[name="title"]');
        if ($title && data.title) {
            $title.value = data.title;
            // уведомляем слушателей, чтобы UI (label вверх) обновился
            $title.dispatchEvent(new Event('input', { bubbles: true }));
            payload.title = data.title;
        }

        // troika: установить тему
        if (data.type === 'troika' && data.demand_id) {
            // попробуем установить select[name="theme"]
            await ensureOptionAndSet('theme', data.demand_id, `/api/demands-for-select?search=&offset=0&limit=200`);
            payload.demand_id = data.demand_id;
        }

        // case: установить exercise (video) и task
        if (data.type === 'case') {
            if (data.exercise_id) {
                // ensure exercise option and set
                await ensureOptionAndSet('exercise', data.exercise_id, `/api/exercises-for-select?search=&offset=0&limit=200`);
                payload.exercise_id = data.exercise_id;

                // create tasks select for this video (if creator available)
                if (typeof globalCreateTasksSelect === 'function') {
                    globalCreateTasksSelect(data.exercise_id);
                }

                // then ensure task option and set
                if (data.task_id) {
                    await ensureOptionAndSet('task', data.task_id, `/api/tasks-for-select/${encodeURIComponent(data.exercise_id)}?search=&offset=0&limit=200`);
                    payload.task_id = data.task_id;
                } else {
                    // если нет task_id — ничего
                }
            }
        }
    }
}
